import { render, staticRenderFns } from "./RenewalRecord.vue?vue&type=template&id=25e52f64&scoped=true&"
import script from "./RenewalRecord.vue?vue&type=script&lang=js&"
export * from "./RenewalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e52f64",
  null
  
)

export default component.exports